import { useAppContext, UniversalStorageUtils, UniversalStorageConstants } from "@thriwe-2-0/thriwe-ui-utils";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useClientConfigProvider } from "./config/client-config-provider";
import AppRoutes from "./constants/routes";

export default function withAuthRedirect(Component: any) {
  return function WrappedComponent(props: any) {
    const { config } = useClientConfigProvider();
    const router = useRouter();

    const auth = !!UniversalStorageUtils.getItem(
      config?.nativeDataSavingType,
      UniversalStorageConstants.AUTH_TOKEN
    );

    useEffect(() => {
      if (auth) {
        const shouldRedirect =
          !config?.userRegistration?.preLoginUserRegister &&
          !config?.userRegistration?.isMembershipLinkedBefore;

        if (shouldRedirect) {
          console.log("redirecting...");
          router.replace(AppRoutes.dashboard);
        }
      }
    }, [auth, config, router]);

    return <Component {...props} />;
  };
}